import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";

import { useCartStore } from "@/components/cart/store";
import { useLocaleNavigation } from "@/hooks/use-locale-navigation";
import { useQrSessionStore } from "@/stores/qr-session";

/**
 * "Your order is on its way." Also where Mollie returns a guest who paid up
 * front, which is why the cart is cleared here rather than before the redirect:
 * a cancelled payment has to leave the basket intact.
 *
 * No status polling. Whether the kitchen has the ticket is not something the
 * guest can act on, and a table order stays open until a waiter closes it, so
 * there is nothing here to refresh.
 */
export const Route = createFileRoute("/$locale/qr/round/$qrRoundId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation("translation");
  const { navigateWithLocale } = useLocaleNavigation();

  const session = useQrSessionStore((state) => state.session);
  const clearCart = useCartStore((state) => state.clearCart);

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
      <CheckCircle2 className="size-14 text-green-600" aria-hidden />

      <h1 className="text-2xl font-bold">{t("Qr.confirmed_title")}</h1>

      <p className="text-gray-600">
        {session
          ? t("Qr.confirmed_description_table", {
              reference: session.tableReference,
            })
          : t("Qr.confirmed_description")}
      </p>

      <button
        type="button"
        onClick={() => navigateWithLocale("/menu")}
        className="min-h-12 w-full max-w-xs cursor-pointer rounded-full bg-black/90 p-2 text-lg font-bold text-white transition-colors hover:bg-black"
      >
        {t("Qr.order_more")}
      </button>
    </div>
  );
}
